import { Autocomplete, TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';
import { TEST_IDS } from 'src/test-ids';
import { forceString } from 'src/utils/forceString';

interface DropdownFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const DropdownField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: DropdownFieldProps) => {
  return (
    <>
      <Autocomplete
        multiple
        freeSolo
        options={(() => {
          const source = (field as any).properties?.dataSource || field.dataSource;
          if (!source) return [];
          try {
            return JSON.parse(forceString(source));
          } catch {
            return [];
          }
        })()}
        value={(() => {
          const source = (field as any).properties?.dataSource || field.dataSource;
          if (!source) return [];
          try {
            return JSON.parse(forceString(source));
          } catch {
            return [];
          }
        })()}
        onChange={(_, newValues) => {
          handleFieldChange(index, {
            dataSource: JSON.stringify(
              newValues.map((value) =>
                typeof value === 'string' ? { name: value.trim(), label: value.trim() } : value,
              ),
            ),
          });
        }}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.label || option.name)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Options"
            placeholder="Type and press enter"
            helperText="Type an option and press enter to add it"
            required
            inputProps={{ ...params.inputProps, 'data-testid': TEST_IDS.DROPDOWN_FIELD.OPTIONS_INPUT }}
          />
        )}
        disabled={isSubmitting || isUsingExistingField}
      />
    </>
  );
};
